<script>
import { onDestroy, tick } from 'svelte';
import { State } from '../store.js';
import { addInspectable, addBodyInspectable } from '../inspectable.js';

var resetFocus = () => {

	if (!$State.live) {
		$State.activeElementId = ""
	}
}

export let pageContainer = null

const unsubscribe = State.subscribe(async (v) => {
	await tick();
	if (pageContainer !== null) {
		addInspectable(pageContainer, $State.page.args, $State.live)

		if (v.live) {
			addBodyInspectable($State.page.args)
		}

	}
})

let resolutionMultiplier = 1.56


</script>

<div class="navbar" class:live={$State.live}>
	<div class="navbar-container">
		<div class="navbar-left"><slot name="navbar-left"></slot></div>
		<img class="logo" src="../static/image/logo.svg" alt="superwall logo">
		<div class="navbar-middle"></div>
		<div class="navbar-right"><slot name="navbar-right"></slot></div>
	</div>
</div>

<div class:live={$State.live} class="app-container" style={`--rm:${resolutionMultiplier}`}>

	
	<div class="side-panel left">
		{#if !$State.live}
			<slot name=left/>
		{/if}
	</div>

	<div bind:this={pageContainer} data-i-name="page-container" class="middle" class:live={$State.live} class:preview={!$State.previewMode} on:click="{resetFocus}">
		<div class="notch"> </div>
		<slot name=middle/>
	</div>

	

	<div class="side-panel right">
		{#if !$State.live}
			<slot name=right/>
		{/if}
	</div>


	
</div>

<style>

.navbar {
	height: auto;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	position: fixed;
	top: 14px;
	/* border-bottom: 1px solid #262729; */
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;   
}

:global(.navbar-right a) {
	margin-left: 10px !important;
}

:global(.navbar-left a) {
	margin-right: 10px !important;
}

.navbar-left, .navbar-right {
	width: 100%;
	max-width: 440px;
}

.navbar-container {
	width: 100%;
	display: flex;
	/* max-width: 1319px; */
	flex-direction: row;
	align-items: center;
	justify-content: space-evenly;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;   
}

img.logo {
	width: 130px;
	position: absolute;
	top: 13px;
	left: calc((100vw - 130px)/2);
}

.navbar.live {
	display: none;
}
	
.app-container {
	width: 100%;
	/* max-width: 1400px; */
	margin-left: auto;
	margin-right: auto;
	padding-top: 50px;
	height: 100vh;
	overflow-y: hidden;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	background-color: var(--dark-bg-color);
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;   
}

.app-container.live {
	background-color: inherit;
	padding-top: 0px;
	-webkit-box-sizing: content-box;
	-moz-box-sizing: content-box;   
	box-sizing: content-box;
	height: auto;
	overflow-y: unset;
}

.navbar-middle {
	width: 100%;
	max-width: 438px;
	min-width: 310px;
}

/*  name: z.string().min(1),
  url: z.string().url(),
  primaryProductIdentifier: z.string(),
  secondaryProductIdentifier: z.string().nullable().optional(),
  tertiaryProductIdentifier: z.string().nullable().optional(),
  primaryProductIdentifierRC: z.string().nullable().optional(),
  secondaryProductIdentifierRC: z.string().nullable().optional(),
  tertiaryProductIdentifierRC: z.string().nullable().optional(),
  presentationStyle: z.nativeEnum(PaywallPresentationStyle),
  showPaywallOption: z.nativeEnum(ShowPaywallOption).optional(),
  paywallDismissal: z.nativeEnum(PaywallDismissal),
  backgroundColorHex: z
    .string()
    .regex(/^\#?[0-9a-fA-F]{6}$/, { message: "Color must match # and 6 hex characters" }),
  applicationId: z.number().optional(),
  substitutions: Substitutions, */

.middle {
	width: 100%;
	max-width: 438px;
	min-width: 310px;
	overflow-y: scroll;
	box-shadow: 0px 0px 50px rgba(0,0,0,0.1);
	border: 1px solid  #262729;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;  
	box-sizing: border-box;    
	margin-top: 20px;
	margin-bottom: 70px;
}

.middle.preview {
	/* border: 0px solid rgba(0,0,0,0); */
	margin-top: 0px;
	margin-bottom: 0px;
}

.middle.live {
	box-shadow: none;
	border: none;
	outline: none;
	margin-top: 0px;
	margin-bottom: 0px;
}

.side-panel {
	width: 100%;
	overflow-y: scroll;
	padding: 20px;
	max-width: 400px;

}

.live .side-panel {
	padding: 0px;
	width: 0px;
}

.left {
	display: flex;
	flex-direction: column;
	justify-content: stretch;
	align-items: center;
	/* width: 430px; */
}


.middle.preview {
	height: calc(13.9cm * var(--rm)) !important;
	width: calc(6.4cm * var(--rm)) !important;
	min-width: calc(6.4cm * var(--rm)) !important;
	justify-self: center;
	align-self: center;
	border-radius: calc(0.9cm * var(--rm));
	padding-top: 0px;
}

.preview .notch {
	width: calc(3.5cm * var(--rm));
	height: calc(0.5cm * var(--rm));
	background-color: red;
	left: calc((100vw - (3.5cm * var(--rm))) / 2);
	margin-top: 0px;
	background-color: var(--dark-bg-color);
	border-bottom-left-radius: calc(0.4cm * var(--rm));
	border-bottom-right-radius: calc(0.4cm * var(--rm));
	position: fixed;
	top: calc(50vh - (13.9cm * var(--rm) * 0.5) - 5px + (0.5cm * var(--rm)));
	z-index: 10;
	border-bottom: 1px solid  #262729;
	border-left: 1px solid  #262729;
	border-right: 1px solid  #262729;
}

/* .middle.preview, .preview .notch {
	border: 10px solid rgba(var(--dark-bg-color-rgb), 0.5);
} */

</style>
